<template>
  <form-section
    :title="$t('CampaignReport_TargetEmail_Target_Title')"
    :description="$t('CampaignReport_TargetEmail_Target_Description')"
  >
    <form-item
      prop="recipients"
      :label="$t('CampaignReport_TargetEmail_EmailsList')"
    >
      <template v-for="(email, index) in model.recipients">
        <div class="rowCt">
          <form-item :rules="rules" :prop="`recipients[${index}]`">
            <el-input
              type="email"
              v-model="model.recipients[index]"
              :placeholder="$t('CampaignReport_TargetEmail_EmailPlaceholder')"
            />
          </form-item>
          <icon class="icon" glyph="bin" @click="removeEmailAddress(index)" />
        </div>
      </template>
      <div>
        <el-button
          type="primary"
          plain
          @click="addEmailAddress"
          :disabled="isAddEmailAddressBtnDisabled()"
        >
          {{ $t('CampaignReport_TargetEmail_AddEmailAddress') }}
        </el-button>
      </div>
    </form-item>
  </form-section>
</template>
<script>
import FormItem from '@/common/components/form/FormItem.vue'
import FormSection from '@/common/components/form/FormSection.vue'

export default {
  name: 'TargetEmailAddress',

  components: { FormSection, FormItem },

  data() {
    return {
      rules: [
        {
          required: true,
          message: this.$t('RestForm_FieldIsRequired'),
          trigger: 'blur'
        },
        {
          type: 'email',
          message: 'Please input correct email address',
          trigger: ['blur', 'change']
        }
      ]
    }
  },

  props: {
    model: {
      type: Object,
      required: true
    }
  },

  mounted() {
    if (this.model.recipients === null) {
      this.model.recipients = ['']
    }
  },

  methods: {
    addEmailAddress() {
      if (this.model.recipients === null) {
        this.model.recipients = []
      }

      this.model.recipients.push('')
    },

    removeEmailAddress(index) {
      if (this.model.recipients.length === 1) {
        return
      }

      if (this.model.recipients[index] === '') {
        this.model.recipients.splice(index, 1)

        return
      }

      this.$msgbox({
        title: this.$t('Common_Popup_Delete_Title'),
        message: this.$t('Common_Popup_Delete_Message'),
        showCancelButton: true,
        confirmButtonText: this.$t('Common_Popup_Delete_Confirm'),
        cancelButtonText: this.$t('Common_Popup_Delete_Cancel'),
        center: true
      })
        .then(() => {
          this.model.recipients.splice(index, 1)
        })
        .catch(() => {})
    },

    isAddEmailAddressBtnDisabled() {
      if (this.model.recipients === null) {
        return false
      }

      return this.model.recipients[this.model.recipients.length - 1] === ''
    }
  }
}
</script>
<style scoped>
.rowCt {
  display: flex;
  padding-bottom: 20px;
}

.rowCt div:not(:last-child) {
  padding-right: 10px;
  width: 300px;
}

.rowCt .icon {
  display: flex;
  justify-content: center;
  width: 25px;
  height: 40px;
  color: #a7acba;
}

.rowCt .icon:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/report/TargetEmailAddress.vue